import { render } from "./InquiryFindings.vue?vue&type=template&id=6d9f3bc7&scoped=true"
import script from "./InquiryFindings.vue?vue&type=script&lang=js"
export * from "./InquiryFindings.vue?vue&type=script&lang=js"

import "./InquiryFindings.vue?vue&type=style&index=0&id=6d9f3bc7&scoped=true&lang=css"

import exportComponent from "E:\\c2stem\\c2-stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9f3bc7"]])

export default __exports__